var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-section',{staticClass:"information",attrs:{"title":_vm.$t('Integrations_Overview_Information')}},[_c('form-section',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info)}})])],1),_vm._v(" "),_c('integration-tasks-table',{attrs:{"integration-id":_vm.model.id,"task-identifiers":['kochava_sync_installs']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bac149b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/integrations/types/kochava/KochavaOverview.vue
// module id = null
// module chunks = 